import {combineReducers} from "redux";

import systemMapViewModel from "./systemMapViewModel";
import dauViewModel from "./dauViewModel";

const rootViewModel = combineReducers({
    systemMapViewModel,
    dauViewModel,
});

export default rootViewModel;
